module.exports = __webpack_public_path__ + "img/parskhazar.18b4a27.png";